export const loginByUsername = (userInfo) => this.$http({
    url: '/auth/login',
    method: 'post',
    data: userInfo
})

export const RefeshToken = (refreshToken) => this.$http({
    url: '/auth/refesh?refreshToken=' + refreshToken,
    method: 'get'
})

export const getUserInfo = () => this.$http({
    url: '/system/current/user/infos',
    method: 'get'
});

export const getMenuAll = () => this.$http({
    url: '/system/current/user/menus',
    method: 'get',
    data: {
        type: 0
    }
});

export const logout = () => this.$http({
    url: '/auth/logout',
    method: 'post'
})


// WEBPACK FOOTER //
// ./src/api/user.js